import * as ASSOCIATION from '../../actionTypes/Association/AssociationActionType';
import Constants from '../../Constants';
import Api from '../../Api';

const api = new Api();

function fetchAssociationsListSuccess(association) {
  return {
    type: ASSOCIATION.ASSOCIATION_LIST,
    association: association,
  };
}

export const fetchAssociationsList = (id = 0, hasSpecialty = false) => {
  return async (dispatch) => {
    const specialtyQuery = hasSpecialty ? '&hasSpecialty=true' : '';
    const url = `${Constants.apiUrls.associationsList}?institutionId=${id}${specialtyQuery}`;
    try {
      const institutions = await api.getData(url);
      // Only update Association User CAS list when not filtering for specialty CASes
      if (!hasSpecialty) {
        dispatch(fetchAssociationsListSuccess(institutions));
      }
      return institutions || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };
};